<div class="onboarding-form">
  <h1>We’re verifying your business information.</h1>
  <p class="text-muted fw-semibold">An email will be sent to confirm the upload of the business certificate.</p>
  <div class="mt-5">
    <button
      id="signupVerifyEmailBtn"
      class="btn btn-primary btn-lg"
      (click)="toDashboard()">
      Continue
      <i class="ms-2 iconoir-arrow-right"></i>
    </button>
  </div>
</div>

<app-profile-dropdown [signUpFlow]="true"></app-profile-dropdown>
